import { render, staticRenderFns } from "./modal_image.vue?vue&type=template&id=0d509b34"
import script from "./modal_image.vue?vue&type=script&lang=js"
export * from "./modal_image.vue?vue&type=script&lang=js"
import style0 from "./modal_image.vue?vue&type=style&index=0&id=0d509b34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports